import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function printHtml(_this__u8e3s4, html, $completion) {
  // Inline function 'kotlin.js.asDynamic' call
  var iframe = document.createElement('iframe');
  iframe.style.position = 'absolute';
  iframe.style.width = '0px';
  iframe.style.height = '0px';
  iframe.style.border = 'none';
  iframe.style.left = '-9999px';
  var tmp0_safe_receiver = document.body;
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver.appendChild(iframe);
  var doc = iframe.contentWindow.document;
  doc.open();
  doc.write(html);
  doc.close();
  iframe.contentWindow.onload = () => {
    var tmp = window;
    return tmp.setTimeout(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      var tmp = window;
      return tmp.setTimeout(() => {
        var tmp0_safe_receiver = document.body;
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.removeChild(iframe);
      }, 1000);
    }, 250);
  };
}
//region block: exports
export {
  printHtml as printHtml1fhajl0naptyz,
};
//endregion

//# sourceMappingURL=printing.js.mjs.map
